/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Backdrop, Box } from "@mui/material";
import { LuiLogoBYAnimation } from "@jda/lui-common-component-library-mui5";

import useStyles from "./styles";

interface ILoader {
  showLoader: boolean;
  isCenter?: boolean;
  customClasses?: string;
  insideLoader?: boolean;
};

const Loader = (props: ILoader) => {
  const classes = useStyles();
  const { showLoader, isCenter, customClasses, insideLoader } = props;
  if (!showLoader) return null;
  const boxProps = isCenter
    ? { textAlign: "center", alignItems: "center" }
    : {};
  if (insideLoader) {
    return (
      <Box className={customClasses || classes.loaderInside} sx={boxProps}>
        <LuiLogoBYAnimation fontSize="small" />
      </Box>
    );
  }
  return (
    <Backdrop open={true} sx={{ zIndex: 10000 }}>
      <Box className={customClasses || classes.loading} sx={boxProps}>
        <LuiLogoBYAnimation fontSize="large" />
      </Box>
    </Backdrop>
  );
};

export default Loader;
